module.exports = __webpack_public_path__ + "img/neutral-face.117845da.png";